import React, { FC } from "react";

interface Props {
  dayOfMonth: number;
  date?: Date | undefined;
  excludedDays?: string[];
  unavailableDays?: string[];
  availabilityData?: {
    [date: string]: {
      hasSlots: boolean;
      priceRange?: { min: number; max: number };
      popularity?: "high" | "medium" | "low";
      isBlocked?: boolean;
    };
  };
}

const DatePickerCustomDay: FC<Props> = ({ dayOfMonth, date, excludedDays, unavailableDays, availabilityData }) => {
  if (!date) return <span>{dayOfMonth}</span>;

  const formattedDate = formatDate(date);
  const isExcluded = excludedDays?.includes(formattedDate);
  const isUnavailable = unavailableDays?.includes(formattedDate);
  const dayData = availabilityData?.[formattedDate];
  const isBlocked = dayData?.isBlocked || isUnavailable;

  // Classes de base
  let dayClass = "react-datepicker__day_span relative cursor-pointer";

  if (isExcluded) {
    dayClass += " react-datepicker__day_span_unavailable";
  } else if (isBlocked) {
    dayClass += " react-datepicker__day_span_blocked bg-red-100 text-red-800 hover:bg-red-200";
  } else {
    dayClass += " react-datepicker__day_span_available bg-green-50 text-green-800 hover:bg-green-100";
  }

  return (
    <span className={dayClass}>
      {dayOfMonth}
      {/* Indicateur de disponibilité */}
      {dayData?.hasSlots && !isExcluded && !isUnavailable && (
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 flex space-x-0.5">
          <div className="w-1 h-1 bg-eventToBee rounded-full"></div>
          {dayData.popularity === "high" && (
            <>
              <div className="w-1 h-1 bg-eventToBee rounded-full"></div>
              <div className="w-1 h-1 bg-eventToBee rounded-full"></div>
            </>
          )}
        </div>
      )}
      {/* Indicateur de prix (optionnel) */}
      {dayData?.priceRange && !isExcluded && !isUnavailable && (
        <div className="absolute -top-1 -right-1 text-xs bg-eventToBee text-white rounded-full w-4 h-4 flex items-center justify-center opacity-75">
          €
        </div>
      )}
    </span>
  );
};

const formatDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default DatePickerCustomDay;
